import React, {useRef} from 'react';
import type {SetRequired} from 'type-fest';
import {useConstCallback} from '@netx/core-components/hooks/useConstCallback';
import {
	NumberField,
	type NumberFieldProps,
} from '@netx/core-components/NumberField';
import {splitEventHandler} from '@netx/core-next/utils';
import {combineRefs} from '@netx/core-next/utils/react';
import {useErrorFocus, useFormInput} from '../hooks';
import type {WithLegacyCommonFormFieldProps} from '../types';

export interface LegacyFormNumberFieldProps
	extends WithLegacyCommonFormFieldProps<
		SetRequired<NumberFieldProps, 'name'>
	> {}

export const LegacyFormNumberFieldPrimitive = (
	{
		error,
		form,
		formFieldOptions,
		onChange,
		...props
	}: LegacyFormNumberFieldProps,
	ref: any,
) => {
	const inputRef = useRef<HTMLInputElement>(null);

	const _error = typeof error === 'string' ? error : error?.message;

	useErrorFocus({
		error: _error,
		inputRef,
	});

	useFormInput(props.name, props.value, form, {
		required: props.required,
		...formFieldOptions,
	});

	const handleChange = useConstCallback(
		splitEventHandler(onChange, (event, value) => {
			form?.setValue(props.name, value);
		}),
	);

	return (
		<NumberField
			ref={ref}
			error={_error}
			{...props}
			inputRef={combineRefs(inputRef, props.inputRef)}
			onChange={handleChange}
		/>
	);
};

/** @deprecated */
export const LegacyFormNumberField = React.forwardRef(
	LegacyFormNumberFieldPrimitive,
);

export default LegacyFormNumberField;
